import { getIsoFieldName, getRightLabelFieldName, getValueFieldName } from '@23degrees/shared-code/config/dimension.config';
import get from 'lodash/get';
import { v4 as uuid } from 'uuid';

export function deepValue(obj, path): any {
  return get(obj, path, null);
}

export function findByValue(obj, key, value) {
  if (obj.hasOwnProperty(key) && obj[key] === value) {
    return obj;
  }

  for (let i = 0; i < Object.keys(obj).length; i++) {
    if (typeof obj[Object.keys(obj)[i]] === 'object') {
      const o = findByValue(obj[Object.keys(obj)[i]], key, value);
      if (o != null) {
        return o;
      }
    }
  }
  return null;
}

export function getTypeKey(key) {
  if (!key) return key;
  return key.substring(0, key.indexOf(':'));
}

export function getTypeIndex(key) {
  if (!key) return key;
  return key.substring(key.indexOf(':') + 1);
}
// TODO this whole function has to be refactored
// aka no direct identifiers
export function getCalcType(key, data, content) {
  if (!key || !data) return;
  key = key.trim();
  const type = key.substring(0, key.indexOf(':')).trim();
  const index = key.substring(key.indexOf(':') + 1).trim();
  const isoFieldName = getIsoFieldName(content?.typeSpecific?.fields);
  const valueFieldName = getValueFieldName(content?.typeSpecific?.dimensions);
  const labelFieldName = getRightLabelFieldName(content.type, content?.typeSpecific?.dimensions);

  

  switch (type) {
    case 'aggregate':
      //input data can have isofields and value fields that are null
      if(valueFieldName && isoFieldName){

        const filterData = data.filter((el) => el[valueFieldName] != null && el[isoFieldName] != null);
        switch (index) {
          case 'sum': {
            if (!key || !data) return;
            return sum(filterData, valueFieldName);
          }
          case 'median': {
            return median(filterData, valueFieldName);
          }
          case 'mean': {
            return mean(filterData, valueFieldName);
          }
        }
      }
      break;
    case 'absolute': {
      if(labelFieldName && valueFieldName){
        const item = data.find((i) => i[labelFieldName] === index);
        if (!item) return;
        return item[valueFieldName];
      }
      break;
    }
    case 'static': {
      return index;
    }
  }
  return false;
}

/**
 * Convert a specific object field from all elements within an arry into real numbers
 *
 * @param {Array} data A list of objects
 * @param {String} valueField The index name of the object field
 * @returns
 * @memberof ObjectUtils
 */
export function parseValuesToNumbers(data, valueField) {
  return data.map((item) => {
    item[valueField] = +deepValue(item, valueField);
    return item;
  });
}

export function transformValue(value) {
  if (value === null || value === 'undefined' || value === 'NA' || value === 'N/A') {
    return null;
  }
  return +value;
}

export function sum(array, key = '') {
  return array.reduce((acc, val) => acc + deepValue(val, key), 0);
}

export function mean(array, key = '') {
  return sum(array, key) / array.length;
}

export function median(array, key = '') {
  array.sort((a, b) => deepValue(a, key) - deepValue(b, key));
  const mid = array.length / 2;
  return mid % 1 ? deepValue(array[mid - 0.5], key) : (deepValue(array[mid - 1], key) + deepValue(array[mid], key)) / 2;
}

export function uid() {
  return uuid();
}

export function groupByValue(data, key) {
  return data.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export function cloneObjectArray(array: any[] | object) {
  return JSON.parse(JSON.stringify(array));
}
export function deepCloneObject(obj: any): any {
  return JSON.parse(JSON.stringify(obj));
}
